import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LockOutlined } from '@ant-design/icons';
import styles from './index.module.scss';

const ToolCard = ({ tool }) => {
  const { i18n } = useTranslation();
  const history = useHistory();
  const userId = useSelector((state) => state.global.userId);
  const dispatch = useDispatch();

  const currentLang = i18n.language;
  const isLocked = tool.requireAuth && !userId;
  const name = tool.name[currentLang] || tool.name.en;
  const description = tool.description[currentLang] || tool.description.en;
  const tags = tool.tags[currentLang] || tool.tags.en;
  const href = `/tools/${tool.id}`;

  const isImageIcon = typeof tool.icon === 'string' && tool.icon.startsWith('/');

  const handleMouseMove = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    event.currentTarget.style.setProperty('--mx', `${event.clientX - rect.left}px`);
    event.currentTarget.style.setProperty('--my', `${event.clientY - rect.top}px`);
  };

  const handleClick = (event) => {
    if (isLocked) {
      event.preventDefault();
      dispatch({
        type: 'global/setShowLogin',
        payload: true,
      });
      return;
    }
    // Standalone tools own their page chrome and require a full document navigation.
    if (tool.standalone) return;
    event.preventDefault();
    history.push(href);
  };

  return (
    <article className={styles.toolArticle} role="listitem">
      <a
        className={styles.toolCard}
        href={href}
        onClick={handleClick}
        onMouseMove={handleMouseMove}
        aria-label={`${name}: ${description}`}
        aria-disabled={isLocked}
      >
        {tool.featured && (
          <div className={styles.featuredBadge}>
            {currentLang === 'zh' ? '推荐' : 'Featured'}
          </div>
        )}
        {isLocked && (
          <div className={styles.lockBadge}>
            <LockOutlined />
          </div>
        )}

        <div
          className={`${styles.icon} ${isImageIcon ? '' : styles.iconTile}`}
          aria-hidden={!isImageIcon}
        >
          {isImageIcon ? <img src={tool.icon} alt={`${name} icon`} /> : tool.icon}
        </div>
        <h3 className={styles.name}>{name}</h3>
        <p className={styles.description}>{description}</p>

        <div className={styles.tags}>
          {tags.map((tag) => (
            <span key={tag} className={styles.tag}>
              {tag}
            </span>
          ))}
        </div>
      </a>
    </article>
  );
};

export default ToolCard;
